import { FC, useState } from "react";
import useScreenSize from "../../../../../custom-hooks/base-hooks/useScreenSize";
import CatalogSortDesktop from "./CatalogSortDesktop";
import CatalogSortMobile from "./CatalogSortMobile";
import { WorksCategoriesForm } from "../../../../../domain/models/dto/WorksCategoriesDTO";
import { FormikProps } from "formik";
import { WorkSearchSortForm } from "../../../../../domain/models/dto/WorkDTO";
import { WorkSortingFields } from "../../../../../domain/enums/entity-fields/WorkSortingFields";

interface CatalogSortProps {
    form: FormikProps<WorkSearchSortForm>;
    disableInactiveCheckbox?: boolean;
    resetFormCallback: () => Promise<void>;
}

const CatalogSort: FC<CatalogSortProps> = (props) => {
    const { upTo1024, moreOrEqual1024 } = useScreenSize();

    const showNonActiveCheckboxHandler = () => {
        props.form.setFieldValue("showInactive", !props.form.values.showInactive);
        props.form.handleSubmit();
    };
    const workCategoriesHandler = (values: WorksCategoriesForm[]) => {
        props.form.setFieldValue("categories", values);
        props.form.handleSubmit();
    };
    const unselectCategoryHandler = (value: WorksCategoriesForm) => {
        props.form.setFieldValue(
            "categories",
            props.form.values.categories.filter((item) => item.category !== value.category),
        );
        props.form.handleSubmit();
    };
    const onOpenWorkCategoriesPopup = () => {
        if (!props.form.touched["categories"]) {
            props.form.setFieldTouched("categories", true);
        }
    };
    const [sortingType, setSortingType] = useState<WorkSortingFields>(null);
    const openingHandler = (currentSort: WorkSortingFields) => {
        return setSortingType(currentSort === sortingType ? null : currentSort);
    };
    const remainingCategories = props.form.values.categories.length - props.form.values.categories.slice(0, 2)?.length;

    return (
        <div className="relative flex flex-col bg-backgroundBlock border border-backgroundButton rounded-[20px] dmax2:rounded-[10px] px-11 dmax2:px-5 py-8 tmax4:py-5 w-full mt-7 tmax4:mt-4">
            {moreOrEqual1024 ? (
                <CatalogSortDesktop
                    form={props.form}
                    disableInactiveCheckbox={props.disableInactiveCheckbox}
                    showNonActiveCheckboxHandler={showNonActiveCheckboxHandler}
                    workCategoriesHandler={workCategoriesHandler}
                    unselectCategoryHandler={unselectCategoryHandler}
                    onOpenWorkCategoriesPopup={onOpenWorkCategoriesPopup}
                    resetFormCallback={props.resetFormCallback}
                    remainingCategories={remainingCategories}
                    sortingType={sortingType}
                    setSortingType={setSortingType}
                    openingHandler={openingHandler}
                />
            ) : (
                upTo1024 && (
                    <CatalogSortMobile
                        form={props.form}
                        disableInactiveCheckbox={props.disableInactiveCheckbox}
                        showNonActiveCheckboxHandler={showNonActiveCheckboxHandler}
                        workCategoriesHandler={workCategoriesHandler}
                        unselectCategoryHandler={unselectCategoryHandler}
                        onOpenWorkCategoriesPopup={onOpenWorkCategoriesPopup}
                        resetFormCallback={props.resetFormCallback}
                        remainingCategories={remainingCategories}
                        sortingType={sortingType}
                        setSortingType={setSortingType}
                        openingHandler={openingHandler}
                    />
                )
            )}
        </div>
    );
};

export default CatalogSort;
